import { type Variables } from 'graphql-request'
import { graphQLClient } from '../client/graphqlClient.config'

export const getDataCMS = async <Data>(query: string, variables: Variables) => { // skipcq: JS-0116
  const client = graphQLClient()
  return client.request<Data>(query, variables)
}
